import { z } from 'zod';

/* 
  post request

  endpoint: '/api/inform/sample-order-service/placeSampleOrder'
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
  body: {
    sampleData: {
      values: [ {
        id,
        kindOfPattern
      }]
    },
    inputData: {
      salutation,
      name,
      surname,
      street,
      houseNumber,
      postalCode,
      location,
    }
  }

  returns any 200 for valid and error for unvalid request
*/

export const enum SampleOrderErrorCodes {
  'SampleCountTooLow' = 'SampleCountTooLow',
  'SampleCountTooHigh' = 'SampleCountTooHigh',
}

export const maximumSamples = 10;

export const sampleDataValueSchema = z.object({
  id: z.string(),
  kindOfPattern: z.number(),
});
export type SampleDataValueSchema = z.infer<typeof sampleDataValueSchema>;

export const sampleDataValuesSchema = z
  .array(sampleDataValueSchema)
  .min(1, SampleOrderErrorCodes.SampleCountTooLow)
  .max(maximumSamples, SampleOrderErrorCodes.SampleCountTooHigh);
export type SampleDataValuesSchema = z.infer<typeof sampleDataValuesSchema>;

export const personalDataFormSchema = z.object({
  salutation: z.union([z.literal('Ms'), z.literal('Mr')]),
  name: z.string().trim().min(2),
  surname: z.string().trim().min(2),
  street: z.string().trim().min(3),
  houseNumber: z.string().trim().min(1),
  postalCode: z.string().trim().min(3),
  location: z.string().trim().min(3),
});
export type PersonalDataFormSchema = z.infer<typeof personalDataFormSchema>;

export const personalDataFormDefaults: PersonalDataFormSchema = {
  salutation: 'Ms',
  name: '',
  surname: '',
  street: '',
  houseNumber: '',
  postalCode: '',
  location: '',
};

export const sampleFormSchema = z.object({
  sampleData: z.object({
    values: sampleDataValuesSchema,
  }),
  inputData: personalDataFormSchema,
});
export type SampleFormSchema = z.infer<typeof sampleFormSchema>;
